var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartBuilderFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H3C2.44772 2 2 2.44772 2 3V15C2 15.5523 2.44772 16 3 16H7C7.55228 16 8 15.5523 8 15V3C8 2.44772 7.55228 2 7 2Z",
    fill: "#030362",
    stroke: "#030362",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H12C11.4477 2 11 2.44772 11 3V4C11 4.55228 11.4477 5 12 5H16C16.5523 5 17 4.55228 17 4V3C17 2.44772 16.5523 2 16 2Z",
    fill: "#9A9AC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5H12C11.4477 7.5 11 7.94772 11 8.5V9.5C11 10.0523 11.4477 10.5 12 10.5H16C16.5523 10.5 17 10.0523 17 9.5V8.5C17 7.94772 16.5523 7.5 16 7.5Z",
    fill: "#9A9AC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H12C11.4477 13 11 13.4477 11 14V15C11 15.5523 11.4477 16 12 16H16C16.5523 16 17 15.5523 17 15V14C17 13.4477 16.5523 13 16 13Z",
    fill: "#9A9AC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartBuilderFilledIcon);
export default __webpack_public_path__ + "static/media/smart-builder-filled-icon.5140d7f39d21165ec40e2a987aec184b.svg";
export { ForwardRef as ReactComponent };